import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import BgImageNew from "../../../assets/images/bgheroscreen.webp";
import BgImageMobile from "../../../assets/images/mHeroBg.svg";
import Goldpartner from "../../../assets/images/goldpartner.png";
import Microsoft from "../../../assets/images/microsoftLogo.svg";
const HeroBannerSeection = () => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        position: "relative",
        height: {
          // 60vh
          xs: "60vh", 
          sm: "calc(100vh - 112px)",
        },
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        color: "#fff",
        padding: 2,
        backgroundImage: {
          xs: `url(${BgImageMobile})`,
          sm: `url(${BgImageNew})`,
        },
        backgroundSize: "cover",
        backgroundPosition: {
          xs: "center -12vh",
          sm: "center -0vh",
        },
        zIndex: 1,
        overflow: "hidden",
      }}
    >
      
      <Typography
        variant="h1"
        component="h1"
        sx={{
          mb: 2,
          fontWeight: 700,
          fontSize: { xs: "30px", md: "82px" },
          lineHeight: {xs:'40px', sm:"114.8px"},
          textAlign: "left",
          background: "linear-gradient(180deg, #F8B62D 0%, #EA5514 100%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        Driving Global Growth
      </Typography>
      <Typography
        py={2}
        variant="body1"
        sx={{
          mb: 4,
          lineHeight: "40px",
          fontWeight: 700,
          color: "#000000",
          fontSize: { xs: "14px", md: "20px" },
          padding: {
            xs: "0px 36px",
            sm: "0px",
          },
          textAlign: "start",
        }}
      >
        海外ビジネス成功のモデルと海外の高度IT人材の活用で
        <br />
        グローバル化とDX化の成功を支えるテクノロジーカンパニー
      </Typography>
      <Button
        onClick={() => navigate("/お問い合わせ-2/")}
        variant="contained"
        sx={{
          backgroundColor: "#FF6000",
          boxShadow: 0,
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "100px",
          cursor: "pointer",
          width: "184px",
          height: "60px",
          fontSize: "16px",
          fontWeight: 700,
          lineHeight: "22px",
          transition: "background-color 5s ease, background 5s ease",
          "&:hover": {
            background: "linear-gradient(180deg, #F8B62D 0%, #EA5514 100%)",
            backgroundColor: "#FF6000",
          },
        }}
      >
        お問い合わせ
      </Button>
      <Box
        sx={{
          position: "absolute",
          left: 30,
          bottom: 30,
          display: { xs: "none", sm: "flex" },
          alignItems: "center",
          gap: 1, 
          padding: 1, 
        }}
      >
        <img src={Goldpartner} alt="Gold Partner" width="130" height="57" style={{ width: "130px", height:'57px' }} />
        <img src={Microsoft} alt="Microsoft" width="152" height="55" style={{ width: "152px", height:'55px' }} />
      </Box>
    </Box>
  );
};
export default HeroBannerSeection;